import { render, staticRenderFns } from "./FilesPagination.vue?vue&type=template&id=5de86c38&"
import script from "./FilesPagination.vue?vue&type=script&lang=js&"
export * from "./FilesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de86c38')) {
      api.createRecord('5de86c38', component.options)
    } else {
      api.reload('5de86c38', component.options)
    }
    module.hot.accept("./FilesPagination.vue?vue&type=template&id=5de86c38&", function () {
      api.rerender('5de86c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/FilesPagination.vue"
export default component.exports